import { DefaultError } from 'errors/DefaultError';
import { sendAdobeEvent } from 'analytics/sendAdobeData';

import type { ErrorResponse } from './types';
export class ApiError extends DefaultError {
  constructor({
    error,
    message,
    title,
    errorCode
  }: {
    error?: ErrorResponse;
    message?: string;
    title?: string;
    errorCode?: string;
  }) {
    const response = error?.data ?? {};
    const status = error?.status ?? 'No HTTP response';
    const url = error?.config?.url ?? 'Unknown URL';
    const method = error?.config?.method?.toUpperCase() ?? 'UNKNOWN';
    const statusText = error?.statusText ? ` (${error.statusText})` : '';

    const shortMsg = `${method} ${url} ${status}${statusText}`;

    super({
      error: new Error(shortMsg),
      name: ApiError.name,
      message: message ?? shortMsg,
      title: title || ApiError.name,
      context: {
        response,
        status,
        url,
        method,
        errorCode
      }
    });

    this.response = error?.data ?? {};
  }

  protected sendAdobeEvent(eventData: Record<string, unknown>): void {
    sendAdobeEvent({ ...eventData, category: 'error' });
  }

  static get name() {
    return 'ApiError';
  }
}
